module.exports = __webpack_public_path__ + "img/receiptStar.f1f4f1a5.svg";